namespace Nobox.Pages {
    export interface InboxModel {
        Id?: number;
        LinkId?: number;
        ExtId?: string;
        Name?: string;
        Desc?: string;
        Status?: number;
        ChannelId?: number;
        ChannelNm?: string;
        AccountIds?: string;
        ListIds?: string;
        Groups?: string;
        Tags?: string;
        Subject?: string;
        InteractiveMsg?: string;
        BodyType?: number;
        ShortLink?: number;
        GenerateMessage?: number;
        Body?: string;
        BodyText?: string;
        BodyHtml?: string;
        TenantId?: number;
        Attachment?: string;
        IsPerContact?: number;
        DataExcel?: string;
        IsSchedule?: number;
        Schedule?: string;
        DataLookupBy?: string;
        ColumnExcel?: string;
        Start?: string;
        End?: string;
        In?: string;
        Up?: string;
        ResultDataExcel?: any[];
    }
}
